import { render, staticRenderFns } from "./BaseAmount.vue?vue&type=template&id=275427d2&functional=true"
import script from "./BaseAmount.vue?vue&type=script&lang=js"
export * from "./BaseAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports